import { useEffect, useState } from 'react';

export function useScroll(alwaysCollapsed = false) {
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(alwaysCollapsed);

  useEffect(() => {
    const handleScroll = () => {
      if (typeof window !== 'undefined') {
        const hasScroll = window.scrollY > 25;

        if (hasScroll !== isNavbarCollapsed) {
          setIsNavbarCollapsed(hasScroll);
        }
      }
    };

    if (!alwaysCollapsed) {
      window.addEventListener('scroll', handleScroll);

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
    return undefined;
  }, [isNavbarCollapsed, alwaysCollapsed]);

  return isNavbarCollapsed;
}
